import moment from "moment";
import React from "react";

import "./invoice.css";
import price from "../../helpers/calculatePrice";

let exclusiveGST;

const Header = ({
  orderNumber,
  branchOrderNumber,
  customerName,
  customerMobile,

  resName,
  orderDate,
  paymentType,
  logo,
  tableNumber,
  orderType,
  gstNumber,
  fssaiNumber,
  branchAddress,
}) => {
  return (
    <>
      <div class="centered">
        {logo && <img src={logo} class="logo" />}
        <p>{resName}</p>
        {branchAddress && <p class="gstNumber">{branchAddress}</p>}
        {fssaiNumber && <p class="gstNumber">FSSAI Number {fssaiNumber}</p>}
      </div>

      <div className="info">
        {customerName && (
          <div className="subinfo">
            <p>
              Name : {customerName}{" "}
              {customerMobile ? `(${customerMobile})` : ""}
            </p>
          </div>
        )}
        <div className="subinfo">
          <p>{branchOrderNumber}</p>
          <p>{moment(orderDate).format("DD/MM/YYYY HH:mm")}</p>
        </div>
        <div className="subinfo">
          <p>{orderType}</p>
          <p>{orderNumber}</p>

          <p>{tableNumber}</p>

          <p>{paymentType}</p>
        </div>
      </div>
    </>
  );
};

const renderRow = (data, value) => {
  return value ? (
    <>
    <tr>
      <td colspan="3" class={data.titleClass}>
      {data.title}
    </td><td colspan="3" class={data.valueClass}>
        {data.hasCurrency ? "₹" : " "} {data.key === "roundOff" && value > 0 ? '+' : ''}{value}
      </td>
    </tr>
    </>
  ) : (
    ""
  );
};

const renderItem = (value, index, i, tableType) => {
  return (
    <React.Fragment key={index}>
      <tr>
        <td class="pro">{value.itemName}</td>
        <td class="quantity">{value.quantity}</td>
        <td class="price">{price(tableType?.tableType, value) || value.itemPrice}</td>
        <td class="amount">{ (value.quantity * price(tableType?.tableType, value)) || value.itemTotal}</td>
      </tr>
    </React.Fragment>
  );
};

const renderTaxItem = (orderData, itemTotal, tableType, chargeDifference) => {
  let itemsTotal = 0;
  let itemPrise = 0;
  orderData.map((value) => {
    itemPrise = ((value.quantity * price(tableType?.tableType, value)) || value.itemTotal);
    itemsTotal += itemPrise + (chargeDifference * (itemPrise / itemTotal));
  });
  let gstAmount = (((orderData[0]?.cgst || 0) + (orderData[0]?.sgst || 0)) / 100) + (exclusiveGST ? 0 : 1);
  let taxAmount = exclusiveGST ? itemsTotal.toFixed(2) : (itemsTotal / gstAmount).toFixed(2);

  return (
    <React.Fragment>
      <tr>
        <td class="pro">{taxAmount}</td>
        <td class="gst">{exclusiveGST ? (taxAmount * gstAmount / 2).toFixed(2) : ((itemsTotal - taxAmount) / 2).toFixed(2)}</td>
        <td class="gst">{exclusiveGST ? (taxAmount * gstAmount / 2).toFixed(2) : ((itemsTotal - taxAmount) / 2).toFixed(2)}</td>
      </tr>
    </React.Fragment>
  );
};

const ProductTable = ({ orderData, tableType }) => {
  const printfooters = [
  {
    title: "Sub Total",
    hasCurrency: true,
    key: "itemsTotal",
    titleClass: "subtotal",
    valueClass: "subtotalamount",
  },
  {
    title: "Table Price(+)",
    hasCurrency: true,
    key: "tablePrice",
    titleClass: "tablePrice",
    valueClass: "tablePriceamount",
  },

  ...(exclusiveGST ? [{
    title: "GST",
    key: "exclusiveGST",
    hasCurrency: true,
    titleClass: "discount",
    valueClass: "discount",
  }] : []),

  {
    title: "Charges(+)",
    hasCurrency: true,
    key: "otherCharges",
    titleClass: "discount",
    valueClass: "discount",
  },

  {
    title: "Discount(-)",
    hasCurrency: true,
    key: "discount",
    titleClass: "discount",
    valueClass: "discount",
  },

  {
    title: "Round off",
    key: "roundOff",
    titleClass: "discount",
    valueClass: "discount",
  },

  {
    title: "Grand Total",
    hasCurrency: true,
    key: "grandTotal",
    titleClass: "grand",
    valueClass: "grandtotal",
  },
];
  return (
    <table class="postable">
      <thead>
        <tr>
          <th class="pro">Item</th>
          <th class="quantity">Qty</th>
          <th class="price">Price</th>
          <th class="amount">Amt</th>
        </tr>
      </thead>
      <tbody>
        {orderData.orderItems
        .filter(value => value.quantity > 0)
        .map((value, index) => {
          const i = ++index;
          return renderItem(value, index, i, tableType);
        })}

        {printfooters.map((foot, footIndex) =>{
            if(foot.key === 'roundOff')
              { 
            let value = parseFloat(orderData.itemsTotal - orderData.discount + orderData.otherCharges);
            let gst = exclusiveGST ? (orderData.cgstCharges + orderData.sgstCharges) : 0
            return renderRow(foot, (orderData.grandTotal - value - gst))
          }
          if(foot.key === 'exclusiveGST' ){
            return renderRow(foot, (orderData.cgstCharges + orderData.sgstCharges))
          }
            return renderRow(foot, orderData[foot.key])}
        )}
      </tbody>
    </table>
  );
};

const TaxSummary = ({ orderData, itemTotal, tableType, gst, chargeDifference }) => {
  return (
    <table class="postable">
      <thead>
        <tr>
          <th class="pro">Taxable Amt</th>
          <th class="gst">{`CGST@${gst}%`}</th>
          <th class="gst">{`SGST@${gst}%`}</th>
        </tr>
      </thead>
      <tbody>
        {
          renderTaxItem(orderData, itemTotal, tableType, chargeDifference)
        }
      </tbody>
    </table>
  );
};

const Invoice = React.forwardRef(
  (
    {
      restaurant,
      orderData,
      count,
      logo,
      gstNumber,
      fssaiNumber,
      receiptMessage,
      branchAddress,
      printSetting,
      tableType,
    },
    ref
  ) => {
    const {
      branchOrderNumber,
      customerName,
      customerMobile,

      orderNumber,
      paymentType,
      updatedAt,
      tableNumber,
      orderType,
    } = orderData;
    // console.log(tableType);
    exclusiveGST = printSetting.exclusiveGST;
    const gstMap = new Map();
    const chargeDifference = orderData?.otherCharges - orderData?.discount;
    let itemTotal = 0;
    orderData.orderItems.map((item) => {
      if(!gstMap.has(item.cgst)){
        gstMap.set(item.cgst, []);
      }

      let itemList = gstMap.get(item.cgst);
      itemList.push(item);
      itemTotal += ((item.quantity * price(tableType?.tableType, item)) || item.itemTotal);
      gstMap.set(item.cgst, itemList);
    })

    const keys = [...gstMap.keys()]

    return (
      <div class="ticket" ref={ref}>
        <Header
          resName={restaurant}
          branchOrderNumber={branchOrderNumber}
          orderNumber={orderNumber}
          customerName={printSetting.enableCustomer && customerName}
          customerMobile={customerMobile}
          paymentType={paymentType}
          orderDate={updatedAt}
          tableNumber={tableNumber}
          orderType={orderType}
          logo={logo}
          gstNumber={gstNumber}
          fssaiNumber={fssaiNumber}
          branchAddress={branchAddress}
        />
        <ProductTable orderData={orderData} tableType={tableType} />

        {gstNumber && <div class="centered" style={{paddingTop: "40px"}}>
          <p>{"Tax Summary"}</p>
          <p class="gstNumber">GST {gstNumber}</p>
        </div>}

        {gstNumber && keys.map((key) => {
            return <TaxSummary orderData={gstMap.get(key)} tableType={tableType} chargeDifference={(chargeDifference || 0)} itemTotal={itemTotal} gst={key}/>
        })}
        {receiptMessage && (
          <p class="centered">
            <p>{receiptMessage}</p>
          </p>
        )}
      </div>
    );
  }
);

class BillComponent extends React.Component {
  render() {
    const {
      logo,
      customAction,
      orderData,
      count,
      restaurant,
      gstNumber,
      fssaiNumber,
      receiptMessage,
      branchAddress,
      printSetting,
      tableType,
    } = this.props;
    // console.log("orderData", orderData);
    return orderData ? (
      <Invoice
        count={count}
        restaurant={restaurant}
        orderData={orderData}
        logo={logo}
        gstNumber={gstNumber}
        fssaiNumber={fssaiNumber}
        receiptMessage={receiptMessage}
        branchAddress={branchAddress}
        printSetting={printSetting}
        tableType={tableType}
      />
    ) : (
      <div className={`invoice-box invoice-box-hide" `}>
        No Data found
      </div>
    );
  }
}
export default BillComponent;
